<template>
  <div id="app">
    <LoaderItem v-if="this.loader" />

    <div class="container">
      <div class="main-column">
        <ul class="breadcrumb">
          <li><a href="/">Home</a></li>
          <li><a>News & Events</a></li>
        </ul>
        <ul class="news-list-items">
          <template v-for="post in posts">
            <ArticleItem
              v-bind:post="post"
            />
          </template>

        </ul>


        <div class="pager-wrapper">
          <paginate v-if="pagesCount > 1"
                    :page-count="pagesCount"
                    :click-handler="changePage"
                    :prev-text="''"
                    :next-text="''"
                    :breac-view-text="'...'"
                    :active-class="'active'"
                    :next-link-class="'next'+(pagesCount == currentPage ? ' disabled' : '')"
                    :prev-link-class="'prev'+(currentPage == 1 ? ' disabled' : '')"
                    :break-view-link-class="'more'"
                    :container-class="'pager'">
          </paginate>
        </div>

      </div>
      <div class="sidebar-column">
        <div class="sidebar">
          <ArticleFilter />

          <div class="grey-sidebar-block sidebar-search-block">
            <form action="/news">
              <div class="fieldset">
                <input name="find" type="text" placeholder="Search news..." v-model="search">
                <input type="submit">
              </div>
            </form>
          </div>

          <div class="sidebar-block grey-sidebar-block request-sidebar-block" v-if="contactForm">
            <div class="inside-content" v-html="contactForm">
            </div>
          </div>

        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import LoaderItem from './components/LoaderItem'
  import ArticleItem from './components/article/ArticleItem'
  import ArticleFilter from './components/article/ArticleFilter'

  export default {
    name: 'article-list',
    components: {LoaderItem, ArticleItem, ArticleFilter},
    comments: [LoaderItem, ArticleItem, ArticleFilter],

    computed: {

      loader() { return this.$store.state.loader },

      posts() {  return this.$store.state.posts.posts },
      pagesCount() { return this.$store.state.posts.max_num_pages },

      select_filters() {
        return this.$store.getters.get_selected_filters;
      },

      filters() { return this.$store.state.filters; },

      currentPage() { return this.$store.state.currentPage; },

    },
    data () {
      return {
        searchParams: {
          q: null,
          type: 'all'
        },

        contactForm: '',

        search: '',
      }
    },

    methods: {

      changePage: function(pageNum) {
        this.$store.commit('SET_LOADER', true);

        this.$store.commit('SET_CURR_PAGE', pageNum);
        this.$store.dispatch('getPosts');

      },

    },
    mounted(){
      this.contactForm = window.cfForm.contact_form;
      this.$store.commit('SET_FILTER',this.$route.query.cat);

      this.search = this.$route.query.find;
      this.$store.commit('SET_SEARCH',this.$route.query.find);

      // console.log(this.$route.query.cat);
      this.$store.dispatch('getPosts');
    },

    updated() {
    },
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/ArticleList.vue